import { useEffect, useRef } from "react";
import { trackScrollDepth } from "./tracking";

const MILESTONES = [25, 50, 75, 90];

// Fires scroll_depth once per milestone per page. Distinct from GA4 Enhanced
// Measurement's built-in single 90% "scroll" event — this adds granularity
// rather than duplicating it. Reset on every pathname change by remounting
// (the caller passes pathname as `key`, or this hook watches it directly).
const useScrollDepth = (pathname) => {
  const firedRef = useRef(new Set());

  useEffect(() => {
    firedRef.current = new Set();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const percent = (scrollTop / docHeight) * 100;

      MILESTONES.forEach((milestone) => {
        if (percent >= milestone && !firedRef.current.has(milestone)) {
          firedRef.current.add(milestone);
          trackScrollDepth(milestone, pathname);
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);
};

export default useScrollDepth;
